import styled from 'styled-components';
import { Button } from '@pearsontechnology/aero-components';

export const ActionButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const SmallButton = styled(Button)`
  padding: 4px 10px;
  font-size: 12px;
  min-height: auto;
`;

export const StatusText = styled.span`
  color: ${(props) => (props.isDenied ? props.theme['color.redLight'] : 'inherit')};
`;

export const EmailPearsonIdColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PearsonIdLine = styled.span`
  display: block;
`;
